//These enums are being to used to save and
// retrieve the values of number of records
//we are showing on the grid of each view
//Slot_1= for perPagetoggle now.

export enum PersonalisationSlotType {
    //this slot is being use to get/save per page toggle
    FirstSlot = 'SLOT_1',

}